import React from 'react';
import { CircularProgress } from 'common/components/material';

const LargeCircularProgress: React.FC = () => (
  <CircularProgress sx={{ alignSelf: 'center' }} size={100} />
);

export default LargeCircularProgress;
